/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Players_View_DeckInputs */



/**
* | output |
* | --- |
* | "View" |
*
* @param {Players_View_DeckInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const players_view_deck = /** @type {((inputs?: Players_View_DeckInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Players_View_DeckInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Voir")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ver")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Ver")
	if (locale === "it") return /** @type {LocalizedString} */ ("Visualizza")
	return /** @type {LocalizedString} */ ("View")
});